module.exports = __webpack_public_path__ + "img/202602_08.8d3e53fb.png";